import React from 'react';
import NumberFormat from 'react-number-format';

const TextField = (props) => {
  const { input, meta, className, placeholder, mask, ...rest } = props;
  const { langs } = window;

  if (mask) {
    return (
    <React.Fragment>
      <NumberFormat
        format={ mask }
        placeholder={ placeholder }
        className={ className }
        { ...input }
        { ...rest }
      />
      {
        meta && meta.error && meta.submitFailed &&
        <span className="text-field__error-message"> { meta.error } </span>
      }
    </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <input
        type="text"
        className={ className }
        placeholder={ placeholder }
        { ...input }
        { ...rest }
      />
      {
        meta && meta.error && meta.submitFailed &&
        <span className="form__error-message"> { langs[meta.error] } </span>
      }
    </React.Fragment>    
  )
};

export default TextField;


// WEBPACK FOOTER //
// ./src/components/TextField/TextField.js